const getIsOpen = (rootState) => rootState.ui.aiChat.isOpen;

export default getIsOpen;
